const MouseIcon = ({ height = '28' }) => (
  <svg
    height={height}
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_707_19789)">
      <mask id="path-1-inside-1_707_19789" fill="white">
        <path d="M17.5226 2.89326L9.02372 5.70576C3.31078 7.60888 3.31078 10.712 9.02372 12.6058L11.5461 13.4401L12.3837 15.9526C14.2849 21.6432 17.4096 21.6432 19.3108 15.9526L22.1437 7.49638C23.4049 3.69951 21.3343 1.62764 17.5226 2.89326ZM17.8237 7.93701L14.2473 11.5183C14.1061 11.6589 13.9273 11.7245 13.7484 11.7245C13.5696 11.7245 13.3908 11.6589 13.2496 11.5183C12.9767 11.2464 12.9767 10.7964 13.2496 10.5245L16.8261 6.94326C17.099 6.67138 17.5508 6.67138 17.8237 6.94326C18.0967 7.21513 18.0967 7.66513 17.8237 7.93701Z" />
      </mask>
      <path
        d="M17.5226 2.89326L9.02372 5.70576C3.31078 7.60888 3.31078 10.712 9.02372 12.6058L11.5461 13.4401L12.3837 15.9526C14.2849 21.6432 17.4096 21.6432 19.3108 15.9526L22.1437 7.49638C23.4049 3.69951 21.3343 1.62764 17.5226 2.89326ZM17.8237 7.93701L14.2473 11.5183C14.1061 11.6589 13.9273 11.7245 13.7484 11.7245C13.5696 11.7245 13.3908 11.6589 13.2496 11.5183C12.9767 11.2464 12.9767 10.7964 13.2496 10.5245L16.8261 6.94326C17.099 6.67138 17.5508 6.67138 17.8237 6.94326C18.0967 7.21513 18.0967 7.66513 17.8237 7.93701Z"
        fill="#7E858F"
        stroke="#212326"
        strokeWidth="1.88249"
        mask="url(#path-1-inside-1_707_19789)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_707_19789"
        x="-1.43306"
        y="0.119141"
        width="30.1182"
        height="30.0299"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.76497" />
        <feGaussianBlur stdDeviation="1.88249" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_707_19789"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_707_19789"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default MouseIcon;
